var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyLight1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "empty-light 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M50 97.29C76.1175 97.29 97.29 76.1175 97.29 50C97.29 23.8824 76.1175 2.70996 50 2.70996C23.8824 2.70996 2.70996 23.8824 2.70996 50C2.70996 76.1175 23.8824 97.29 50 97.29Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M49.2197 28.71V58.07L76.8797 43.39L49.2197 28.71Z",
    fill: "#0B3F30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M49.2203 58.0703V86.8703L21.5703 72.1903V63.3303L30.7603 67.9603L49.2203 58.0703Z",
    fill: "#00B76D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M49.2204 28.7101L30.6004 18.8301L2.94043 33.5101L21.5704 43.3901L49.2204 28.7101Z",
    fill: "#C9F2DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M49.2204 58.0696L21.5704 43.3896L2.94043 53.2796L30.7604 67.9596L49.2204 58.0696Z",
    fill: "#C9F2DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M49.2203 28.71V58.07L21.5703 43.39L49.2203 28.71Z",
    fill: "#C9F2DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M67.8397 18.8301L49.2197 28.7101L76.8797 43.3901L95.4997 33.5101L67.8397 18.8301Z",
    fill: "#C9F2DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M49.2197 58.0696L76.8797 43.3896L95.4997 53.2796L67.8397 67.9596L49.2197 58.0696Z",
    fill: "#C9F2DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M49.2197 58.0703V86.8703L76.8797 72.1903V63.1603L67.8397 67.9603L49.2197 58.0703Z",
    fill: "#C9F2DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M21.5703 43.3902L48.1703 29.6602L37.5803 51.8902L21.5703 43.3902Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M30.6004 67.9601L2.94043 53.2801L67.8404 18.8301L95.5004 33.5101L30.6004 67.9601Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M2.94043 33.5101L30.6004 18.8301L95.5004 53.2801L67.8404 67.9601L2.94043 33.5101Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M76.8803 72.1904L49.2203 86.8704L21.5703 72.1904",
    stroke: "#3A3A3A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M21.5703 63.3302V72.1902L49.2203 86.8702L76.8803 72.1902V63.1602",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M49.2197 86.87V58.07V28.71",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M53.1602 39.1201C52.8302 39.1401 52.4902 39.1501 52.1602 39.1501",
    stroke: "#1E1E1E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M50.16 38.9804C45.02 38.1204 40.38 34.2104 38.98 29.1504C37.32 23.1204 40.48 16.1104 46.12 13.3904C48.11 12.4304 50.49 11.9904 52.51 12.8804C54.53 13.7704 55.87 16.3104 54.91 18.3004C54.01 20.1504 51.68 20.7704 49.63 20.7904C45.72 20.8404 41.8 19.4404 38.8 16.9304C36.31 14.8504 34.46 12.0104 33.54 8.90039",
    stroke: "#1E1E1E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M33.2898 7.93996C33.2098 7.61996 33.1498 7.28996 33.0898 6.95996",
    stroke: "#1E1E1E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M65.7703 11.4995C66.4551 11.4995 67.0103 10.9444 67.0103 10.2595C67.0103 9.5747 66.4551 9.01953 65.7703 9.01953C65.0854 9.01953 64.5303 9.5747 64.5303 10.2595C64.5303 10.9444 65.0854 11.4995 65.7703 11.4995Z",
    stroke: "#2B2B2B",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M19.1697 20.0601C19.8545 20.0601 20.4097 19.5049 20.4097 18.8201C20.4097 18.1352 19.8545 17.5801 19.1697 17.5801C18.4849 17.5801 17.9297 18.1352 17.9297 18.8201C17.9297 19.5049 18.4849 20.0601 19.1697 20.0601Z",
    stroke: "#2B2B2B",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyLight1);
export default __webpack_public_path__ + "static/media/empty-light1.bc2894f9a18bf8d5d44aee40e5565e3d.svg";
export { ForwardRef as ReactComponent };